import { SearchTableQuery } from 'owa-mail-list-search';
import { MailListRowDataType } from 'owa-mail-list-store';
import { action } from 'satcheljs';

const loadMessageSuggestionIntoTable = action(
    'loadMessageSuggestionIntoTable',
    (
        actionSource: string,
        row: MailListRowDataType,
        searchTableQuery: SearchTableQuery,
        referenceId: string,
        traceId: string,
        itemPartId?: string
    ) => ({
        actionSource,
        row,
        searchTableQuery,
        referenceId,
        traceId,
        itemPartId,
    })
);

export default loadMessageSuggestionIntoTable;
